/* nexturn-cart-guard.js
 *
 * The swap button on the cart guard. Base-theme agnostic: it talks only to the
 * Cart AJAX API, which every Online Store 2.0 theme exposes at the same paths.
 *
 * Liquid renders the guard itself (it already has cart data server-side, so
 * rendering it client-side would flash the wrong state on load). This file only
 * handles the click. Wire it up by giving the button the variant ids:
 *
 *   <button class="swap" type="button"
 *           data-nexturn-swap
 *           data-set-variant="{{ set_variant_id }}"
 *           data-set-plan="{{ set_selling_plan_id }}"    (optional; blank unless a selling-plan app is ever installed again)
 *           data-set-property="Ships in ...">          (optional; the Preorder line-item property, same text as the product templates)
 *     Switch to the Table Set · $99
 *   </button>
 *
 * where set_variant_id is the NTSET4 variant. The NTDEV1 lines are found by
 * re-reading /cart.js after the add. Include once, in layout/theme.liquid or
 * the cart section:
 *
 *   {{ 'nexturn-cart-guard.js' | asset_url | script_tag }}
 *
 * Deliberately NOT a full cart re-render: after a successful swap it reloads.
 * Cart pages are cheap, reload is what every theme's own quantity controls fall
 * back to, and it keeps this file independent of the base theme's DOM.
 */
(function () {
  "use strict";

  var SINGLE_SKU = "NTDEV1"; // same SKU the Liquid guard counts
  var btn = document.querySelector("[data-nexturn-swap]");
  if (!btn) return;

  function post(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) {
        // Surface Shopify's own message where there is one: sold out, cart
        // locked during checkout, inventory moved underneath us.
        return res.json().then(
          function (j) { throw new Error(j.description || j.message || "Cart error " + res.status); },
          function () { throw new Error("Cart error " + res.status); }
        );
      }
      return res.json();
    });
  }

  btn.addEventListener("click", function () {
    var setVariant = btn.getAttribute("data-set-variant");
    var setPlan = btn.getAttribute("data-set-plan");
    var setProperty = btn.getAttribute("data-set-property");
    if (!setVariant) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Switching…";

    // Add first, remove second. If the add fails (sold out, batch closed) the
    // buyer still has the cart they had, rather than an empty one plus an error.
    // If a selling plan is ever attached to the set again, Shopify refuses a
    // plain add for it, so send the plan when the page rendered one
    // (data-set-plan is empty for a product with no plan).
    var add = { id: Number(setVariant), quantity: 1 };
    if (setPlan) add.selling_plan = Number(setPlan);
    // Same hidden line-item property the product templates submit, so the
    // swapped-in set carries the preorder line through checkout and the email.
    if (setProperty) add.properties = { Preorder: setProperty };
    post("/cart/add.js", add)
      .then(function () {
        // Remove the singles by line POSITION, re-read after the add: Shopify
        // puts the new line at the top, so positions rendered into the page are
        // stale, and removing by line item key came back "No valid id or line
        // parameter" on the live store (Horizon itself only ever uses `line`).
        // Highest position first so earlier ones do not shift underneath us.
        return fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var lines = [];
            (cart.items || []).forEach(function (it, i) {
              if (it.sku === SINGLE_SKU) lines.push(i + 1);
            });
            return lines.reverse().reduce(function (chain, line) {
              return chain.then(function () { return post("/cart/change.js", { line: line, quantity: 0 }); });
            }, Promise.resolve());
          });
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = original;
        var note = document.createElement("p");
        note.className = "swap-error";
        note.setAttribute("role", "alert");
        note.textContent = err.message || "Could not switch. Please try again.";
        if (!btn.parentNode.querySelector(".swap-error")) btn.parentNode.appendChild(note);
        if (window.console) console.error("[nexturn] cart swap failed", err);
      });
  });
})();
